<template>
        <div class="p-fluid formgrid grid">
            <div v-if="(form.resume != 'none')" class="field col-12">
                <label for="name3">{{ $t('cv-attached') }} :</label>
                <a :href="form.resume" target="_blank"> Klik Disini</a>
            </div>
            <div v-if="(form.foto != 'none' || !form.foto)" class="field col-12">
                <Image
                    :src="form.foto"
                    preview="true"
                    width="250"
                />
            </div>
            <div class="field col-12 md:col-3">
                <label for="name3">{{ $t('applied-vacant') }}</label>
                <InputText id="id_card_number" type="text" v-model="form.vacancies_id" readonly />
            </div>
            <div class="field col-12 md:col-3">
                <label for="name3">{{ $t('id-card-number') }}</label>
                <InputText id="id_card_number" type="text" v-model="form.id_card_number" :class="{ 'p-invalid': submitted && !form.id_card_number }" />
                <small class="p-invalid" v-if="submitted && !form.id_card_number">{{ $t('id-card-number') }} is required.</small>
            </div>
            <div class="field col-12">
                <label for="name3">{{ $t('name') }}</label>
                <InputText id="name" type="text" v-model="form.name" />
            </div>
            <div class="field col-12 md:col-3">
                <label for="email3">{{ $t('gender') }}</label>
                <Dropdown v-model="form.gender" :options="genderValues" optionLabel="name" optionValue="code" placeholder="Select Gender" :class="{'p-invalid' : submitted && !form.gender}" />
                    <small class="p-invalid" v-if="submitted && !form.gender"
                        >{{ $t('gender') }} is required.</small
                    >
            </div>
            <div class="field col-12 md:col-4">
                <label for="email3">{{ $t('birthplace') }}</label>
                <InputText id="birthplace" type="text" v-model="form.birthplace" />
            </div>
            <div class="field col-12 md:col-5">
                <label for="email3">{{ $t('birthdate') }}</label>
                <Calendar :showIcon="true"
                        :showButtonBar="true"
                        v-model="form.birthdate"
                        :class="{'p-invalid' : submitted && !form.birthdate}"
                        dateFormat="yy-mm-dd">
                </Calendar>
                <small class="p-invalid" v-if="submitted && !form.birthdate"
                    >{{ $t('birthplace') }} is required.</small
                >
            </div>
            <div class="field col-12 md:col-4">
                <label for="email3">{{ $t('email') }}</label>
                    <InputText id="email3" type="text" v-model="form.email" />
            </div>
            <div class="field col-12 md:col-4">
                <label for="email3">{{ $t('telephone-number') }}</label>
                    <InputText id="birthplace" type="text" v-model="form.telephone_number" />
            </div>
            <div class="field col-12 md:col-4">
                <label for="email3">{{ $t('phone-number') }}</label>
                    <InputText id="birthplace" type="text" v-model="form.phone_number" />
            </div>
            <div class="field col-12">
                <label for="email3">{{ $t('address') }}</label>
                    <TextArea
                        id="address"
                        name="address"
                        v-model="form.address"
                        required="true"
                        rows="5"
                        cols="50"
                        :class="{'p-invalid' : submitted && !form.address}"
                    >
                    </TextArea>
                    <small class="p-invalid" v-if="submitted && !form.address"
                        >{{ $t('address') }} is required.</small
                    >
            </div>
            <div class="field col-12">
                <label for="email3">Alamat Domisili</label>
                    <TextArea
                        id="address_2"
                        name="address_2"
                        v-model="form.address_2"
                        required="true"
                        rows="5"
                        cols="50"
                        :class="{'p-invalid' : submitted && !form.address_2}"
                    >
                    </TextArea>
                    <small class="p-invalid" v-if="submitted && !form.address_2"
                        >Alamat Domisili is required.</small
                    >
            </div>
            <div class="field col-12 md:col-4">
                <label for="email3">{{ $t('blood-type') }}</label>
                    <Dropdown v-model="form.blood_type" :options="bloodTypeValues" placeholder="Select Blood Type" :class="{'p-invalid' : submitted && !form.blood_type}" />
                    <small class="p-invalid" v-if="submitted && !form.blood_type"
                        >{{ $t('blood-type') }} is required.</small
                    >
            </div>
            <div class="field col-12 md:col-4">
                <label for="email3">{{ $t('last-education') }}</label>
                    <Dropdown v-model="form.last_formal_education" :options="lastEducationLevels" optionLabel="name" optionValue="id" placeholder="Select Education Level" :class="{'p-invalid' : submitted && !form.last_formal_education}" />
                    <small class="p-invalid" v-if="submitted && !form.last_formal_education"
                        >{{ $t('last-education') }} Level is required.</small
                    >
            </div>
            <div class="field col-12 md:col-4">
                <label for="email3">{{ $t('gpa') }}</label>
                <InputText id="birthplace" type="text" v-model="form.gpa" :class="{'p-invalid' : submitted && !form.gpa}" />
                <small class="p-invalid" v-if="submitted && !form.gpa"
                        >{{ $t('gpa') }} is required.</small
                    >
            </div>
            <div class="field col-12 md:col-3">
                <label for="email3">{{ $t('religion') }}</label>
                    <Dropdown v-model="form.religion" :options="religions" placeholder="Select Religion" :class="{'p-invalid' : submitted && !form.religion}" />
                    <small class="p-invalid" v-if="submitted && !form.religion"
                        >{{ $t('religion') }} is required.</small
                    >
            </div>
            <div class="field col-12 md:col-3">
                <label for="email3">{{ $t('nationality') }}</label>
                <Dropdown v-model="form.nationality" :options="nationalities" option-label="name" option-value="id"
                placeholder="Select Nationalities" :class="{ 'p-invalid': submitted && !form.nationality }"></Dropdown>
                <small class="p-invalid" v-if="submitted && !form.nationality"
                    >{{ $t('nationality') }} is required.</small
                >
            </div>
            <div class="field col-12 md:col-3">
                <label for="email3">{{ $t('clan') }}</label>
                <InputText id="birthplace" type="text" v-model="form.clan" :class="{'p-invalid' : submitted && !form.clan}" />
                <small class="p-invalid" v-if="submitted && !form.clan"
                    >{{ $t('clan') }} is required.</small
                >
            </div>
            <div class="field col-12 md:col-3">
                <label for="email3">{{ $t('marital-status') }}</label>
                <Dropdown v-model="form.marital_status" :options="maritalStatus" placeholder="Select Marital Status" :class="{'p-invalid' : submitted && !form.marital_status}" />
                <small class="p-invalid" v-if="submitted && !form.marital_status"
                    >{{ $t('marital-status') }} is required.</small
                >
            </div>
            <Button
                label="Apply"
                class="p-button p-component p-button-primary"
                @click="onSubmit"
            />
        </div>
</template>
<script>
import axios from 'axios';
import { FilterMatchMode } from "primevue/api";
import InputText from 'primevue/inputtext';
import Button from "primevue/button";
import Image from "primevue/image";
import TextArea from "primevue/textarea";
import Dropdown from "primevue/dropdown";
import Calendar from 'primevue/calendar';

export default {
    components:{
        Button,
        InputText,
        TextArea,
        Dropdown,
        Calendar,
        Image,
    },
    data(){
        return{
            form: this.$page.props.candidate.data,
            genderValues: [
                {name: 'Laki-Laki', code: 'Laki-laki'},
                {name: 'Perempuan', code: 'Perempuan'},
            ],
            bloodTypeValues: ["A", "B", "O", "AB"],
            religions:['Islam','Katolik','Kristen','Hindu','Budha'],
            maritalStatus:['married','single','widow'],
            submitted:false,
            lastEducationLevels:null,
            nationalities: "",
        }
    },
    mounted(){
        this.initData();
    },
    methods:{
        initData(){
            axios.get(this.route("education.levels"))
            .then((data) => {
                this.lastEducationLevels = data.data.data;
            })
            .catch((error) => {
                this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: error,
                    life: 3000,
                });
            });
            axios.get(`${this.$page.props.appUrl}api/nationalities`)
            .then((data) => {
                this.nationalities = data.data.data
            });
        },
        onSubmit(){
            this.submitted=true;
            if(this.form){
                axios.put(route('applicants.update', this.form.id),this.form)
                .then((response) => {
                    this.form = response.data.data;
                    this.$toast.add({
                        severity: "success",
                        summary: "Successful",
                        detail: "Candidate Updated",
                        life: 3000,
                    });
                })
                .catch((error) => {
                    this.$toast.add({
                        severity: "error",
                        summary: "Error",
                        detail: "Candidate Update Failed",
                        life: 3000,
                    });
                })
            }
        }
    }
}
</script>
